import { SearchWebIcon } from './SearchWebIcon';

/**
 * author: Michael Richins
 * id F6E7F332-1625-4A46-8E10-B6DEC4059E7E
 * name search-web
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/search-web.svg
 * tags
 */
export const SearchGlobeIcon = SearchWebIcon;
export default SearchGlobeIcon